import ddt from '@wix/da-ddt';
import { ModalType } from '../Modals/redux/types';
function getSessionStorageItem(key) {
    var value = window.sessionStorage.getItem(key);
    if (value !== null) {
        window.sessionStorage.removeItem(key);
    }
    return value;
}
export function initPopups(config) {
    if (typeof window === 'undefined') {
        return;
    }
    if (!window.sessionStorage) {
        return;
    }
    var modal = getSessionStorageItem('sisuModal');
    if (modal) {
        ddt.log('shared', 'sisu modal: ', modal);
    }
    // TODO implement all modals
    switch (modal) {
        case 'welcome':
            config.pushModal(ModalType.SISU_WELCOME, {});
            break;
        case 'welcomeback':
            break;
        case 'verify':
            break;
        case 'social':
            var token = getSessionStorageItem('sisuToken');
            var authMode = getSessionStorageItem('sisuAuthMode');
            ddt.log('shared', 'sisu token: ', token, ', authMode: ', authMode);
            if (token && authMode) {
                config.pushSisuSocialModal(authMode, token);
            }
            break;
        default:
    }
}
//# sourceMappingURL=initPopups.js.map